import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { LabelProps } from "./Types";
import { useTranslations } from "./../../contexts/translationContext";

const FieldLabel: React.FC<LabelProps> = ({ text, required, labelSize, style }) => {
    const [label, setLabel] = useState<string>(text);
    const { translate } = useTranslations();

    translate('FieldLabel.' + text, undefined, text)
        .then(translated => setLabel(translated));

    if (labelSize === 'auto') {
        return (
            <Form.Label>
                {label}
                {required && <span className="required">*</span>}
            </Form.Label>
        );
    }

    let labelSm = 2;
    if (labelSize)
        labelSm = labelSize;

    return (
        <Form.Label column sm={labelSm} style={style}>
            {label}
            {required && <span className="required">*</span>}
        </Form.Label>
    );
}
export default FieldLabel;
